export const PULL_USER_NOTIFICATIONS = 'PULL_USER_NOTIFICATIONS';
export const SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS';
export const MARK_NOTIFICATIONS_PROCESSED = 'MARK_NOTIFICATIONS_PROCESSED';
export const SET_USER_NOTIFICATIONS_LOADING = 'SET_USER_NOTIFICATIONS_LOADING';

export const pullUserNotificationsAction = () => ({
  type: PULL_USER_NOTIFICATIONS
});

export const setUserNotificationsAction = notifications => ({
  type: SET_USER_NOTIFICATIONS,
  notifications
});

export const markNotificationsProcessedAction = notificationIds => ({
  type: MARK_NOTIFICATIONS_PROCESSED,
  notificationIds
});

export const setUserNotificationsLoadingAction = loading => ({
  type: SET_USER_NOTIFICATIONS_LOADING,
  loading
});
